import {EmergencyContact, EmergencyContactCreateDTO, EmergencyContactUpdateDTO} from "../models/emergencyContact";
import {authFetch} from "../auth/authFetch";

const API_BASE = "/api/emergency_contacts";

export async function getEmergencyContactsByAccount(accountId: number): Promise<EmergencyContact[]> {
    return getEmergencyContactsByAccountId(`${API_BASE}/${accountId}/allByAccount`);
}

export async function getSharedEmergencyContactsByAccount(requesterId: number, targetId: number): Promise<EmergencyContact[]> {
    return getEmergencyContactsByAccountId(`${API_BASE}/${requesterId}/${targetId}`);
}

async function getEmergencyContactsByAccountId(url: string): Promise<EmergencyContact[]> {
    const res = await authFetch(url);

    if (!res.ok) {
        throw new Error("Failed to fetch contacts for account");
    }

    return res.json();
}

export async function getEmergencyContactById(id: number): Promise<EmergencyContact> {
    const res = await authFetch(`${API_BASE}/${id}`);

    if (!res.ok) {
        throw new Error(`Contact with id ${id} not found`);
    }

    return res.json();
}

export async function createEmergencyContact(dto: EmergencyContactCreateDTO): Promise<EmergencyContact> {
    const res = await authFetch(API_BASE, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(dto)
    });

    if (!res.ok) {
        throw new Error("Failed to create emergency contact");
    }

    return res.json();
}

export async function updateEmergencyContact(id: number, dto: EmergencyContactUpdateDTO): Promise<EmergencyContact> {
    const res = await authFetch(`${API_BASE}/${id}`, {
        method: "PATCH",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(dto)
    });

    if (!res.ok) {
        throw new Error(`Failed to update contact with id ${id}`);
    }

    return res.json();
}

export async function deleteEmergencyContact(id: number): Promise<void> {
    const res = await authFetch(`${API_BASE}/${id}`, {
        method: "DELETE"
    });

    if (!res.ok) {
        throw new Error(`Failed to delete contact with id ${id}`);
    }
}
